<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择员工"
      class="customer-edit"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        module="basic"
        url="employees">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="员工编号">
            <el-input v-model.trim="filter.employeeNO" clearable/>
          </vm-search>
          <vm-search label="姓名">
            <el-input v-model.trim="filter.employeeName" clearable/>
          </vm-search>
          <vm-search label="手机">
            <el-input v-model.trim="filter.mobile" clearable/>
          </vm-search>
        </div>
      </template>
<!--      <el-table-column type="selection" align="center" width="55"/>-->
      <el-table-column prop="employeeNO" align="center" label="员工编号"/>
      <el-table-column prop="outerNo" align="center" label="外部编号"/>
      <el-table-column prop="employeeName" align="center" label="姓名"/>
      <el-table-column prop="gender" align="center" label="性别"/>
      <el-table-column prop="departmentName" align="center" label="部门"/>
      <el-table-column prop="postName" align="center" label="职位"/>
      <el-table-column prop="telephone" align="center" label="电话"/>
      <el-table-column prop="mobile" align="center" label="手机"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";


  export default {
    name:"Employee2Select",
    components: {VmTable,VmSearch},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        idList: "",
        index: "",
        filter: {
          employeeNO: "",
          employeeName: "",
          mobile: "",
        },
      };
    },
    methods: {
      open(index) {
        this.dialogVisible = true;
        this.index = index;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", this.index,row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
